// prettier-ignore
import { lazy } from 'react';

import { Navigate } from 'react-router-dom';
import { RouteProps } from './types';

import loginRoutes from './phioLoginRoutes';
import PrivateRoute from '../apps/phio/components/PrivateRoute';
import RegistrationRegionProvider from '../apps/phio/containers/PatientRegistration/RegistrationRegionProvider';

const SandboxContainer = lazy(
    () => import('../TheBot/Sandbox/IframeSandboxFrame'),
);
const Controller = lazy(() => import('../apps/phio/containers/Controller'));
const IframeContextContainer = lazy(
    () => import('../apps/phio/containers/IframeContextContainer'),
);
const PhioEntryContainer = lazy(
    () => import('../apps/phio/containers/PhioContainer/PhioEntryContainer'),
);
const AccessFaq = lazy(() => import('../apps/phio/containers/Faq/AccessFaq'));
const AccessFaqTopic = lazy(
    () => import('../apps/phio/containers/Faq/AccessFaqTopic'),
);
const AccessSupport = lazy(
    () => import('../apps/phio/containers/Faq/AccessSupport'),
);
const EngageFaq = lazy(() => import('../apps/phio/containers/Faq/EngageFaq'));
const CircleHealth = lazy(
    () => import('../apps/circleHealth/containers/CircleSplashScreen'),
);
const IndexRouteContainer = lazy(
    () => import('../apps/phio/containers/IndexContainer'),
);
const Auth = lazy(() => import('../apps/phio/containers/Auth'));
const Privacy = lazy(() => import('../apps/phio/containers/Privacy/Privacy'));
const EngagePrivacy = lazy(
    () => import('../apps/phio/containers/Privacy/EngagePrivacy'),
);
const Cookie = lazy(() => import('../apps/phio/containers/Cookie/Cookie'));
const Terms = lazy(() => import('../apps/phio/containers/Terms/Terms'));
const EngageTerms = lazy(
    () => import('../apps/phio/containers/Terms/EngageTerms'),
);
const AppAuth = lazy(() => import('../apps/phio/containers/AppAuth'));
const AppDownload = lazy(() => import('../apps/phio/containers/AppDownload'));
const PatientRegistration = lazy(
    () => import('../apps/phio/containers/PatientRegistration'),
);
const LoginLayout = lazy(
    () => import('../apps/phio/components/LoginLayout/LoginLayout'),
);
const BrightSandboxContainer = lazy(
    () => import('../TheBot/Sandbox/BrightSandboxContainer'),
);
const InvalidPath = lazy(() => import('../apps/phio/components/InvalidPath'));
const PatientRecordDownload = lazy(
    () => import('../apps/phio/containers/PatientRecordDownload'),
);

const phioRoutes: RouteProps[] = [
    {
        path: '/restricted',
        element: <IframeContextContainer />,
        routeName: 'Restricted',
    },
    {
        path: '/patient_record_download/:token',
        element: <PatientRecordDownload />,
        routeName: 'Patient Record Download',
    },
    {
        path: '/patient_record_download/:token/:region',
        element: <PatientRecordDownload />,
        routeName: 'Patient Record Download',
    },
    { path: '/download', element: <AppDownload />, routeName: 'App Download' },
    { path: '/app_auth', element: <AppAuth />, routeName: 'App Auth' },
    { path: '/sandbox', element: <SandboxContainer />, routeName: 'sandbox' },
    {
        path: '/authenticate/:shortUrl',
        element: <Auth />,
        routeName: 'authenticate',
    },
    {
        path: '/auth',
        element: <LoginLayout />,
        routeName: 'Login',
        children: loginRoutes,
    },
    {
        path: '/chat',
        element: (
            <PrivateRoute>
                <PhioEntryContainer />
            </PrivateRoute>
        ),
        routeName: 'Chat',
    },
    {
        path: '/chat_sandbox',
        element: <BrightSandboxContainer />,
        routeName: 'playground',
    },

    {
        path: '/faq',
        element: <Navigate to="/faq/access" replace />,
        routeName: 'FAQ',
    },
    {
        path: '/faq/access/:topicSlug',
        element: <AccessFaqTopic />,
        routeName: 'Access FAQ Topic',
    },
    { path: '/faq/access', element: <AccessFaq />, routeName: 'Access FAQ' },
    {
        path: '/support/access',
        element: <AccessSupport />,
        routeName: 'Access Support',
    },
    { path: '/faq/engage', element: <EngageFaq />, routeName: 'Engage FAQ' },
    { path: '/privacy', element: <Privacy />, routeName: 'Privacy' },
    {
        path: '/engage/privacy',
        element: <EngagePrivacy />,
        routeName: 'Engage Privacy',
    },
    {
        path: '/engage/privacy-aus',
        element: <EngagePrivacy />,
        routeName: 'Engage Privacy - Australia',
    },
    { path: '/cookie', element: <Cookie />, routeName: 'Cookie' },
    { path: '/terms', element: <Terms />, routeName: 'Terms' },
    {
        path: '/engage/terms',
        element: <EngageTerms />,
        routeName: 'Engage Terms',
    },
    {
        path: '/engage/terms-aus',
        element: <EngageTerms />,
        routeName: 'Engage Terms - Australia',
    },
    {
        path: '/provider/:providerName',
        element: (
            <RegistrationRegionProvider>
                <PatientRegistration />
            </RegistrationRegionProvider>
        ),
        routeName: 'PatientRegistration',
    },
    {
        path: '/circlehealth',
        element: <CircleHealth />,
        routeName: 'Circle Health',
    },
    { path: '/:linkId', element: <Controller />, routeName: 'Controller' },
    {
        path: '/',
        element: <IndexRouteContainer />,
        routeName: 'Index',
    },
    {
        path: '*',
        element: <InvalidPath />,
        routeName: 'InvalidPath',
    },
];

export default phioRoutes;
